export default {"src":"/_next/static/media/Vector-half-circle3.abbfd341.svg","height":86,"width":172,"blurWidth":0,"blurHeight":0};